import { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { IResponseData } from '@/core/interfaces/common'
import { WalletOperationResponse } from '@/core/services/Wallets/WalletInterface'
import { cn } from '@bem-react/classname'

import './WalletOperations.scss'

interface IWalletOperationsProps {
  className?: string
  transactions?: IResponseData<WalletOperationResponse[]>
  code: string
}

const cnWalletOperations = cn('WalletOperations')
const cnTable = cn('Table')

export const WalletOperations: FC<IWalletOperationsProps> = ({
  className,
  transactions,
  code,
}) => {
  const { t } = useTranslation()
  const [data, setData] = useState<WalletOperationResponse[]>([])

  useEffect(() => {
    if (transactions && transactions.data.length > 0) {
      setData(transactions.data)
    }
  }, [transactions])

  return (
    <div className={cnWalletOperations(null, [className])}>
      <table className={cnTable()}>
        <thead>
          <tr className={cnTable('row')}>
            <th className={cnTable('th')}> {t('wallet-type')}</th>
            <th className={cnTable('th')}> {t('wallet-txid')}</th>
            <th className={cnTable('th')}> {t('wallet-date')}</th>
            <th className={cnTable('th')}> {t('wallet-amount')}</th>
          </tr>
        </thead>
        <tbody>
          {data.map(el => (
            <tr key={el.id} className={cnTable('row')}>
              <td className={cnTable('td')}>
                <div
                  className={cnWalletOperations('direction', {
                    sent: el.direction.name.toLowerCase() === 'sent',
                    received: el.direction.name.toLowerCase() === 'received',
                  })}
                >
                  {t(`wallet-status-${el.direction.name.toLowerCase()}`)}
                </div>
              </td>
              <td className={cnTable('td')}>
                <a href={el.tx_url} className={cnTable('link')} target='_blank'>
                  {t('wallet-view-explorer')}
                </a>
              </td>
              <td className={cnTable('td')}>
                <div className={cnWalletOperations('date')}>{el.date}</div>
                <div className={cnWalletOperations('time')}>{el.time}</div>
              </td>
              <td className={cnTable('td')}>
                <div className={cnWalletOperations('date')}>
                  {el.amount} {code}
                </div>
                <div className={cnWalletOperations('time')}>
                  {el.amount_usd} USD
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
